import React from "react";
import WorldMap from "./WorldMap";
import InViewReveal from "./InViewReveal";
import SectionWatermark from "./SectionWatermark";

/**
 * Routes - vintage cartographic map of active trade lanes.
 * Map is interactive: click a region to filter the SVG lanes.
 */

export default function GlobalPresence() {
  return (
    <section id="presence" className="relative paper" style={{ overflow: "hidden" }}>
      <SectionWatermark variant="compass" position="top-right" size={420} opacity={0.18} />
      <div className="relative px-6 sm:px-10 py-14 md:py-20" style={{ zIndex: 1 }}>

        <InViewReveal className="flex items-baseline gap-4 mb-8 md:mb-12">
          <span className="folio">№ 04</span>
          <span className="rule rule-grow" style={{ flex: 1, height: 1 }} />
          <span className="folio" style={{ color: "var(--ink-mute)" }}>ROUTES &amp; TIMETABLE</span>
        </InViewReveal>

        <div className="grid md:grid-cols-12 gap-10 md:gap-12 mb-10 md:mb-14">
          <InViewReveal delay={2} className="md:col-span-7">
            <h2 className="display" style={{ fontSize: "clamp(40px, 5vw, 72px)", lineHeight: 1, letterSpacing: "-0.02em" }}>
              From Mundra,
              <br/>
              <em className="display-italic" style={{ color: "var(--vermilion)" }}>onward.</em>
            </h2>
          </InViewReveal>
          <InViewReveal delay={3} className="md:col-span-5 lg:col-span-4 lg:col-start-9">
            <p style={{ fontSize: "clamp(17px, 1.25vw, 20px)", lineHeight: 1.65, color: "var(--ink-soft)" }}>
              Twelve regular ports of arrival, served from the four major Indian ports
              (Mundra · Kandla · Nhava Sheva · Chennai). Transit windows below are
              indicative of dry containers; reefer routes vary.
            </p>
          </InViewReveal>
        </div>

        {/* Cartographic plate */}
        <InViewReveal delay={2} className="mb-10 md:mb-14">
          <WorldMap />
        </InViewReveal>

        {/* Closing signature - small wax seal */}
        <InViewReveal delay={3} className="mt-8 md:mt-10 flex items-center gap-4">
          <div className="wax-seal" style={{ width: 44, height: 44, fontSize: 17 }}>S</div>
          <div>
            <div className="display-italic" style={{ fontSize: 18, lineHeight: 1.1 }}>Stamped manifest</div>
            <div className="meta mt-1">REGISTRY · GUJARAT EXPORT COUNCIL</div>
          </div>
        </InViewReveal>
      </div>
    </section>
  );
}
